/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityError
 */
export interface IdentityError {
    /**
     * 
     * @type {string}
     * @memberof IdentityError
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityError
     */
    description?: string | null;
}

/**
 * Check if a given object implements the IdentityError interface.
 */
export function instanceOfIdentityError(value: object): value is IdentityError {
    return true;
}

export function IdentityErrorFromJSON(json: any): IdentityError {
    return IdentityErrorFromJSONTyped(json, false);
}

export function IdentityErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityError {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IdentityErrorToJSON(json: any): IdentityError {
    return IdentityErrorToJSONTyped(json, false);
}

export function IdentityErrorToJSONTyped(value?: IdentityError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'description': value['description'],
    };
}

